import { render, staticRenderFns } from "./DashboardOverviewNumberOfTodayOrdersTile.vue?vue&type=template&id=9bcd909a"
import script from "./DashboardOverviewNumberOfTodayOrdersTile.vue?vue&type=script&lang=js"
export * from "./DashboardOverviewNumberOfTodayOrdersTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports